import {getApi} from '../../modules/common/utils/api'

const api = getApi('default')

export function getReservationItemDetails({group_id, uid}) {
  return api.get(`v3/${group_id}/reservation_item/${uid}`)
}

export function sendEmailSupport() {
  return api.get(`v3/upgrade_reservation_email`)
}
